/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Company,
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
} from './Company';

/**
 * 
 * @export
 * @interface SearchedCompaniesResponseAllOfData
 */
export interface SearchedCompaniesResponseAllOfData {
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof SearchedCompaniesResponseAllOfData
     */
    nextCursor?: string;
    /**
     * 
     * @type {Array<Company>}
     * @memberof SearchedCompaniesResponseAllOfData
     */
    companies: Array<Company>;
    /**
     * 検索結果の総数
     * @type {number}
     * @memberof SearchedCompaniesResponseAllOfData
     */
    totalCount: number;
}

export function SearchedCompaniesResponseAllOfDataFromJSON(json: any): SearchedCompaniesResponseAllOfData {
    return SearchedCompaniesResponseAllOfDataFromJSONTyped(json, false);
}

export function SearchedCompaniesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedCompaniesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
        'companies': ((json['companies'] as Array<any>).map(CompanyFromJSON)),
        'totalCount': json['total_count'],
    };
}

export function SearchedCompaniesResponseAllOfDataToJSON(value?: SearchedCompaniesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'next_cursor': value.nextCursor,
        'companies': ((value.companies as Array<any>).map(CompanyToJSON)),
        'total_count': value.totalCount,
    };
}

